import React from 'react';
import { styled } from '@mui/material/styles';
import { Fade } from '@mui/material';
import Introduction from './components/Introduction';
import RegisterOnlineBrokerForm from '../../../components/forms/RegisterOnlineBrokerForm';

const RegisterOnlineBrokerTrainingRoot = styled('div')(({ theme }) => ({}));

const RegisterOnlineBrokerTraining = () => {
    return (
        <Fade in={true}>
            <RegisterOnlineBrokerTrainingRoot>
                <Introduction />

                <RegisterOnlineBrokerForm />
            </RegisterOnlineBrokerTrainingRoot>
        </Fade>
    );
};

export default RegisterOnlineBrokerTraining;
